import React, {useState , useEffect} from 'react';
import StartScreen from './components/start-screen';
import Questions from './components/questions';
import Resultat from './components/resultat';
import './App.css';

function App() {  
  const [step , setStep] = useState(0);
  const [data ,setData] = useState({});
  const [display , setDisplay] = useState(<StartScreen setStep={setStep}/>);

  const nextStep = () => ( setStep(step+1));
  const restart  = () => {
    setData({});
    setStep(0);
  };
    
  useEffect(()=>{
    if (step === 0 ){
      setDisplay( <StartScreen setStep={setStep}/>);
    }else if (step === 1) {
      setDisplay ( <Questions restart ={restart} nextStep = {nextStep} setData={setData}/> );
    } else if (step === 2 ) {
      setDisplay( <Resultat answers={data.answers} restart={restart}/> );
    }
  } , [step]);

  return (
    <div className="simulateur simulateur_prime_noel">
      {display}
    </div>
  );
}

export default App;
